/**
 * Note Field Row
 *  This is notes row component in a card component
 */
import { createStyles, makeStyles } from '@material-ui/core';
import { Typography } from '../Typography';
import React from 'react';
const useStyles = makeStyles((theme) => createStyles({
    wrapper: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        display: 'flex',
        alignItems: 'flex-start',
        '&:first-child': {
            marginTop: 0,
        },
    },
    textWrapper: {
        marginTop: theme.spacing(0.75),
        marginLeft: theme.spacing(1.75),
    },
}));
const NoteFieldRow = ({ icon, children, iconColor }) => {
    const classes = useStyles({});
    const iconComponent = React.createElement(icon);
    return (React.createElement("div", { className: classes.wrapper },
        React.createElement("span", { style: { color: iconColor } }, iconComponent),
        React.createElement(Typography, { fontWeight: "regular", color: "textSecondary", variant: "caption", className: classes.textWrapper }, children)));
};
export default NoteFieldRow;
//# sourceMappingURL=NoteFieldRow.js.map